<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Notificaties</h2>

                <table class="table table-hover" width="100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                        <th scope="col">Bericht</th>
                        <th scope="col" style="text-align:right">Datum</th>
                    </tr>
                    </thead>
                    <tr v-for="(notification, index) in notifications" :key="index">
                        <td>{{ notification.message }}</td>
                        <td align="right">{{ notification.created_at | formatDate }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
	import moment from 'moment-timezone'

	export default {
		props: ['notifications'],

		data () {
			return {
				isLoading: false,
			}
		},

		methods: {
			handleClosePopup () {
				this.$emit('togglePopup')
			},
		},

		filters: {
			formatDate (value) {
				return moment(value).locale('nl').format('LLL')
			},
		},
	}
</script>